/**
 * Throws `message` or a stable default when a runtime invariant fails.
 * @example
 * ```ts
 * assert(isString(value), 'Value must be a string')
 * ```
 */
export function assert(condition: any, message?: string): asserts condition {
	if (!condition) {
		throw new Error(message || 'Assertion failed')
	}
}

export function isString(value: unknown): value is string {
	return typeof value === 'string'
}

/** Accepts canonical dashed UUID strings regardless of hex casing. */
export function isUUID(value: unknown): value is string {
	return (
		typeof value === 'string' &&
		/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
			value,
		)
	)
}
